import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA, ThemePalette } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { AngularFireDatabase } from '@angular/fire/database';
import { PODB_controller } from 'src/app/Services/DB_Controller/PODB_controller';
import { PartTracker, PurchaseOrder } from 'src/app/Services/Object_Classes/PurchaseOrder/PurchaseOrder';
import { v4 as uuidv4 } from 'uuid';
import * as moment from 'moment';
import { InvoiceDB_controller } from '../../../Services/DB_Controller/InvoiceDB_controller';
import { Invoice } from 'src/app/Services/Object_Classes/Invoice/Invoice';
import { AngularFireAuth } from '@angular/fire/auth';
import { NgxSpinnerService } from 'ngx-spinner';
import { PartDB_controller } from '../../../Services/DB_Controller/PartDB_controller';
import { Part } from 'src/app/Services/Object_Classes/Part/Part';
import { PackingList } from 'src/app/Services/Object_Classes/PackingList/PackingList';
import { AngularFireStorage } from '@angular/fire/storage';
import { PackingListDB_controller } from '../../../Services/DB_Controller/PackingListDB_controller';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-update-invoice',
  templateUrl: './update-invoice.component.html',
  styleUrls: ['./update-invoice.component.css']
})
export class UpdateInvoiceComponent implements OnInit {
  poNo = '';
  totalPart: any;
  partNumber: any;
  quantity: any;
  po_controller: PODB_controller = new PODB_controller(this.db);
  invoice_controller: InvoiceDB_controller = new InvoiceDB_controller(this.db);
  availableMachineList: any[] = [];
  selectedMachineList: any[] = [];
  matSelectPO: PurchaseOrder[] = [];
  matSelectPart=[];
  addForm: FormGroup;
  clone = [];
  newPO: PurchaseOrder = new PurchaseOrder();
  shippingDate = new Date();
  shipDate = [];
  searchPart: any;
  searchPO: any;
  check = false;
  check2 = false;
  selectedParts: PartTracker[] = [];
  newInvoice: Invoice = new Invoice();
  email:string;
  @ViewChild('picker', {static: true}) picker: any;
  temporaryInvoiceNum: string = "";
  part_controller: PartDB_controller = new PartDB_controller(this.db, this.storage,this.firestore);
  partsList: Part[] = [];
  // partUnitPrice: any[] = [];
  // partMouldPrice: any[] = [];
  // partRemark: any[] = [];
  priceList: string = "0";
  linkPackingList: PackingList = new PackingList();
  selectedCurrency: string = 'MYR';
  selectedInvoice: Invoice = new Invoice();
  packing_controller: PackingListDB_controller = new PackingListDB_controller(this.db,this.firestore);

  public date: moment.Moment;

  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
    date2: new FormControl(null, [Validators.required])
  });

  public options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ];

  invoice:Invoice;
  packinglist : PackingList[] = []
  packinglistNumber = [];
  fixedPrice: string;
  constructor(
    private dialogRef: MatDialogRef<UpdateInvoiceComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private fb: FormBuilder,
    private toast: ToastrService,
    private db: AngularFireDatabase,
    private firestore: AngularFirestore,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private spinner : NgxSpinnerService,
    private storage : AngularFireStorage
  ) {
   this.invoice = data.invoice;
   this.selectedCurrency = this.invoice.Currency;
   this.angularFireAuth.authState.subscribe(auth=>{
    this.email = auth.email;
  })

   this.invoice.Invoice_PackingList.forEach(element=>{
     element.POList.forEach(d=>{
      d.Invoice_PO_Part_List.forEach(r=>{
        if(r.MouldPrice === '-')
          r.MouldPrice = "0";
        this.priceList = (parseFloat(this.priceList) + (parseFloat(r.PartPrice) * r.Part_Quantity)  +(r.MouldPrice == "-" ? 0 : parseFloat(r.MouldPrice))).toFixed(2);
      })
     })

  })

  this.addForm = this.fb.group({
    name: this.invoice.Invoice_No,
    Price: this.priceList,
  });
  this.fixedPrice = this.priceList;
  }

  ngOnInit() {

  }


  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    if( isNaN(this.addForm.get('Price').value)){
      this.toast.warning("Invalid mould price. please check")
      return;
    }
    const dialogConfig = new MatDialogConfig;
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = '80%';
    const position = {
      top: '5%'
    };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm update this invoice?';
    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async confirm => {
      if(confirm){
        this.invoice_controller.update_Invoice(this.invoice, this.addForm.get('Price').value, this.email);
        this.dialogRef.close();
      }
    });

  }

  calculateUnit(){
    this.priceList = "0";
    this.invoice.Invoice_PackingList.forEach(element=>{
      element.POList.forEach(d=>{
        d.Invoice_PO_Part_List.forEach(e=>{
          this.priceList = (parseFloat(this.priceList) + (parseFloat(e.PartPrice) * e.Part_Quantity) +(e.MouldPrice == "-" ? 0 : parseFloat(e.MouldPrice))).toFixed(2);
       })
      })
    })
    this.fixedPrice = this.priceList;
    this.addForm.get('Price').setValue(this.priceList);
  }
}
